import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    createReferralMemo: -1,
    referralPreview: -1,
    referralMemos: -1,
  },
  createReferralMemo: null,
  referralPreview: null,
  referralMemos: [],
  metaReferralMemos: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;
  const isLoadMore = meta?.isLoadMore ?? false;

  switch (type) {
    case ACTION_TYPES.REFERRAL_MEMO_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createReferralMemo: 0,
        },
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMO_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          createReferralMemo: 1,
        },
        data: payload.data,
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMO_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createReferralMemo: 2,
        },
        error,
      };
    case ACTION_TYPES.REFERRAL_MEMO_PREVIEW_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          referralPreview: 0,
        },
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMO_PREVIEW_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          referralPreview: 1,
        },
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMO_PREVIEW_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          referralPreview: 2,
        },
        error,
      };
    case ACTION_TYPES.REFERRAL_MEMOS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          referralMemos: 0,
        },
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMOS_GET_SUCCEED:
      return {
        ...state,
        referralMemos: isLoadMore ? [...state.referralMemos, ...payload.data] : payload.data,
        metaReferralMemos: payload.meta,
        status: {
          ...state.status,
          referralMemos: 1,
        },
        error: null,
      };
    case ACTION_TYPES.REFERRAL_MEMOS_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          referralMemos: 2,
        },
        error,
      };
    default:
      return state;
  }
}
